interface Team {
  id: number;
  franchiseId: number;
  fullName: string;
  leagueId: number;
  rawTricode: string;
  triCode: string;
  colors: string[];
  conference: string;
  division: string;
}

const allTeams: Team[] = [
  {
    id: 24,
    franchiseId: 32,
    fullName: "Anaheim Ducks",
    leagueId: 133,
    rawTricode: "ANA",
    triCode: "ANA",
    colors: ["#EC410B", "#FFFFFF", "#010101"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 6,
    franchiseId: 6,
    fullName: "Boston Bruins",
    leagueId: 133,
    rawTricode: "BOS",
    triCode: "BOS",
    colors: ["#FFB81C", "#000000", "#FFFFFF"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 7,
    franchiseId: 19,
    fullName: "Buffalo Sabres",
    leagueId: 133,
    rawTricode: "BUF",
    triCode: "BUF",
    colors: ["#041e42", "#ffb81c", "#ffffff"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 20,
    franchiseId: 21,
    fullName: "Calgary Flames",
    leagueId: 133,
    rawTricode: "CGY",
    triCode: "CGY",
    colors: ["#CE1126", "#F1B42F", "#000000"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 12,
    franchiseId: 26,
    fullName: "Carolina Hurricanes",
    leagueId: 133,
    rawTricode: "CAR",
    triCode: "CAR",
    colors: ["#c8102e", "#FFFFFF", "#010101"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 16,
    franchiseId: 11,
    fullName: "Chicago Blackhawks",
    leagueId: 133,
    rawTricode: "CHI",
    triCode: "CHI",
    colors: ["#c8102e", "#FFFFFF", "#010101"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 21,
    franchiseId: 27,
    fullName: "Colorado Avalanche",
    leagueId: 133,
    rawTricode: "COL",
    triCode: "COL",
    colors: ["#6F263D", "#ffffff", "#236192"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 29,
    franchiseId: 36,
    fullName: "Columbus Blue Jackets",
    leagueId: 133,
    rawTricode: "CBJ",
    triCode: "CBJ",
    colors: ["#011E41", "#ffffff", "#CE1126"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 25,
    franchiseId: 15,
    fullName: "Dallas Stars",
    leagueId: 133,
    rawTricode: "DAL",
    triCode: "DAL",
    colors: ["#006847", "#FFFFFF", "#000000"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 17,
    franchiseId: 12,
    fullName: "Detroit Red Wings",
    leagueId: 133,
    rawTricode: "DET",
    triCode: "DET",
    colors: ["#C8102E", "#FFFFFF", "#A2AAAD"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 22,
    franchiseId: 25,
    fullName: "Edmonton Oilers",
    leagueId: 133,
    rawTricode: "EDM",
    triCode: "EDM",
    colors: ["#041E42", "#FFFFFF", "#FF4C00"],
    conference: "Western",
    division: "Pacific",
  },

  {
    id: 13,
    franchiseId: 33,
    fullName: "Florida Panthers",
    leagueId: 133,
    rawTricode: "FLA",
    triCode: "FLA",
    colors: ["#c8102E", "#B9975B", "#041E42"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 26,
    franchiseId: 14,
    fullName: "Los Angeles Kings",
    leagueId: 133,
    rawTricode: "LAK",
    triCode: "LAK",
    colors: ["#000000", "#A2AAAD", "#FFFFFF"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 30,
    franchiseId: 37,
    fullName: "Minnesota Wild",
    leagueId: 133,
    rawTricode: "MIN",
    triCode: "MIN",
    colors: ["#154734", "#DDCBA4", "#A6192E"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 8,
    franchiseId: 1,
    fullName: "Montréal Canadiens",
    leagueId: 133,
    rawTricode: "MTL",
    triCode: "MTL",
    colors: ["#AF1E2D", "#FFFFFF", "#002F6C"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 18,
    franchiseId: 34,
    fullName: "Nashville Predators",
    leagueId: 133,
    rawTricode: "NSH",
    triCode: "NSH",
    colors: ["#FFB81C", "#FFFFFF", "#00205B"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 1,
    franchiseId: 23,
    fullName: "New Jersey Devils",
    leagueId: 133,
    rawTricode: "NJD",
    triCode: "NJD",
    colors: ["#E30613", "#FFFFFF", "#000000"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 2,
    franchiseId: 22,
    fullName: "New York Islanders",
    leagueId: 133,
    rawTricode: "NYI",
    triCode: "NYI",
    colors: ["#073886", "#ffffff", "#fd5d20"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 3,
    franchiseId: 10,
    fullName: "New York Rangers",
    leagueId: 133,
    rawTricode: "NYR",
    triCode: "NYR",
    colors: ["#003DA5", "#FFFFFF", "#C8102E"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 9,
    franchiseId: 30,
    fullName: "Ottawa Senators",
    leagueId: 133,
    rawTricode: "OTT",
    triCode: "OTT",
    colors: ["#C8102E", "#B79257", "#000000"],
    conference: "Eastern",
    division: "Atlantic",
  },

  {
    id: 4,
    franchiseId: 16,
    fullName: "Philadelphia Flyers",
    leagueId: 133,
    rawTricode: "PHI",
    triCode: "PHI",
    colors: ["#F74902", "#000000", "#FFFFFF"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 5,
    franchiseId: 17,
    fullName: "Pittsburgh Penguins",
    leagueId: 133,
    rawTricode: "PIT",
    triCode: "PIT",
    colors: ["#000000", "#FFB81C", "#FFFFFF"],
    conference: "Eastern",
    division: "Metropolitan",
  },

  {
    id: 14,
    franchiseId: 31,
    fullName: "Tampa Bay Lightning",
    leagueId: 133,
    rawTricode: "TBL",
    triCode: "TBL",
    colors: ["#00205B", "#A2AAAD", "#FFFFFF"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 28,
    franchiseId: 29,
    fullName: "San Jose Sharks",
    leagueId: 133,
    rawTricode: "SJS",
    triCode: "SJS",
    colors: ["#006D80", "#FFFFFF", "#000000"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 55,
    franchiseId: 39,
    fullName: "Seattle Kraken",
    leagueId: 133,
    rawTricode: "SEA",
    triCode: "SEA",
    colors: ["#001628", "#99d9d9", "#355464"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 19,
    franchiseId: 18,
    fullName: "St. Louis Blues",
    leagueId: 133,
    rawTricode: "STL",
    triCode: "STL",
    colors: ["#002F87", "#FCB514", "#041E42"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 10,
    franchiseId: 5,
    fullName: "Toronto Maple Leafs",
    leagueId: 133,
    rawTricode: "TOR",
    triCode: "TOR",
    colors: ["#00205B", "#FFFFFF", "#00205B"],
    conference: "Eastern",
    division: "Atlantic",
  },
  {
    id: 68,
    franchiseId: 40,
    fullName: "Utah Mammoth",
    leagueId: 133,
    rawTricode: "UTA",
    triCode: "UTA",
    colors: ["#000000", "#FFFFFF", "#7cb3df"],
    conference: "Western",
    division: "Central",
  },
  {
    id: 23,
    franchiseId: 20,
    fullName: "Vancouver Canucks",
    leagueId: 133,
    rawTricode: "VAN",
    triCode: "VAN",
    colors: ["#00205B", "#00843d", "#ffffff"],
    conference: "Western",
    division: "Pacific",
  },
  {
    id: 54,
    franchiseId: 38,
    fullName: "Vegas Golden Knights",
    leagueId: 133,
    rawTricode: "VGK",
    triCode: "VGK",
    colors: ["#B4975A", "#ffffff", "#000000"],
    conference: "Western",
    division: "Pacific",
  },

  {
    id: 15,
    franchiseId: 24,
    fullName: "Washington Capitals",
    leagueId: 133,
    rawTricode: "WSH",
    triCode: "WSH",
    colors: ["#C8102E", "#FFFFFF", "#041E42"],
    conference: "Eastern",
    division: "Metropolitan",
  },
  {
    id: 52,
    franchiseId: 35,
    fullName: "Winnipeg Jets",
    leagueId: 133,
    rawTricode: "WPG",
    triCode: "WPG",
    colors: ["#041E41", "#FFFFFF", "#AC162C"],
    conference: "Western",
    division: "Central",
  },
];

export default allTeams;
